module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-0 kios-item"
  }, [_c('div', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#ffffff"
    }
  }, [(_vm.agencies.length === 1) ? _c('h4', {
    staticClass: "py-1 text-xs-center",
    staticStyle: {
      "color": "green",
      "text-transform": "uppercase"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.agencies[0]['administrationName']) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "py-2 mx-3 text-xs-center"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("DANH SÁCH HỒ SƠ CÓ KẾT QUẢ NGÀY " + _vm._s(_vm.fromDate()) + " \n            "), (_vm.dossierList.length > 0) ? _c('span', [_vm._v("(Tổng số: " + _vm._s(_vm.dossierList.length) + " hồ sơ)")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "py-3 mx-3"
  }, [_c('v-layout', {
    staticClass: "mb-3",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm6": ""
    }
  }, [_c('div', {
    staticClass: "input-custom"
  }, [_c('input', {
    attrs: {
      "id": "dossierNoKey",
      "type": "text",
      "required": "required"
    },
    on: {
      "focus": _vm.show,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchKeyword($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "dossierNoKey"
    }
  }, [_vm._v("Mã hồ sơ, tên chủ hồ sơ")]), _vm._v(" "), _c('v-icon', {
    staticClass: "icon-prepend text-bold",
    attrs: {
      "size": "18"
    },
    on: {
      "click": _vm.searchKeyword
    }
  }, [_vm._v("search")])], 1)])], 1), _vm._v(" "), (_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _c('div', [(_vm.dossierList.length > 0) ? _c('div', [_c('v-data-table', {
    staticClass: "table-bordered",
    attrs: {
      "headers": _vm.headerTable,
      "items": _vm.dossierList,
      "pagination": _vm.pagination,
      "hide-actions": "",
      "light": ""
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: {
            'active': props.index % 2 == 1
          }
        }, [_c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', [_vm._v(_vm._s(_vm.pagination.page * _vm.pagination.rowsPerPage - _vm.pagination.rowsPerPage + props.index + 1))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.dossierNo))]), _c('br')]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.applicantName))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.receiveDate))])]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('span', [_vm._v(_vm._s(props.item.releaseDate))])])])]
      }
    }], null, false, 97893056)
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "mt-3",
    attrs: {
      "value": true,
      "outline": "",
      "color": "blue",
      "icon": "priority_high"
    }
  }, [_vm._v("\n                Không có hồ sơ có kết quả ngày " + _vm._s(_vm.fromDate()) + "\n              ")])], 1), _vm._v(" "), (_vm.dossierList.length > 10) ? _c('div', {
    staticClass: "text-xs-center layout wrap mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "flex pagging-table px-2"
  }, [_c('tiny-pagination', {
    attrs: {
      "total": _vm.dossierList.length,
      "page": _vm.pagination.page,
      "custom-class": "custom-tiny-class"
    },
    on: {
      "tiny:change-page": _vm.paggingData
    }
  })], 1)]) : _vm._e()], 1)], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "fab": "",
      "color": "primary"
    },
    on: {
      "click": _vm.changeScreen
    }
  }, [(!_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen")]) : _vm._e(), _vm._v(" "), (_vm.fullScreen) ? _c('v-icon', {
    attrs: {
      "size": "20",
      "dark": ""
    }
  }, [_vm._v("fullscreen_exit")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.visible && !_vm.isMobile) ? _c('div', {
    staticClass: "virtual-keyboard"
  }, [_c('v-btn', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    },
    attrs: {
      "small": "",
      "fab": "",
      "color": "#383533"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#fff"
    }
  }, [_vm._v("clear")])], 1), _vm._v(" "), (_vm.visible) ? _c('vue-touch-keyboard', {
    attrs: {
      "layout": _vm.layout,
      "cancel": _vm.hide,
      "accept": _vm.accept,
      "input": _vm.input,
      "next": _vm.next,
      "options": _vm.options
    }
  }) : _vm._e()], 1) : _vm._e()], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2ce8ac97", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ce8ac97"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HoSoKetQua.vue
// module id = 525
// module chunks = 1